import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Header from './components/Header/Header';
import Home from './pages/Home/Home';
import FullSoundCatalog from './pages/FullSoundCatalog/FullSoundCatalog';
import { CATALOG_AT_SUBPATH_ROOT, ROUTER_BASENAME } from './config/appRoutes';

function MainSite() {
  const [showSlidebar, setShowSlidebar] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const productionSection = document.getElementById('production');
      if (productionSection) {
        const rect = productionSection.getBoundingClientRect();
        setShowSlidebar(rect.top <= window.innerHeight * 0.5);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App">
      <Header showSlidebar={showSlidebar} />
      <main className="main-content">
        <Home />
      </main>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter basename={ROUTER_BASENAME}>
      <Routes>
        {CATALOG_AT_SUBPATH_ROOT ? (
          <>
            <Route path="/" element={<FullSoundCatalog />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        ) : (
          <>
            <Route path="/full" element={<FullSoundCatalog />} />
            <Route path="/full/*" element={<FullSoundCatalog />} />
            <Route path="/FULLSOUNDCATALOG" element={<Navigate to="/full" replace />} />
            <Route path="*" element={<MainSite />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
